class LqdUITheme extends elementorModules.ViewModule {
  
  getDefaultSettings() {
    
    return {
      editorPreferencesModel: elementor.settings.editorPreferences.model,
      darkModeLinkID: 'liquid-elementor-editor-style-dark-css'
    }

  }
  
  getDefaultElements() {

    const darkModeLinkID = this.getSettings('darkModeLinkID');
    
    return {
      $darkModeLink: jQuery(`#${darkModeLinkID}`)
    }

  }
  
  bindEvents() {
    
    const editorPreferencesModel = this.getSettings('editorPreferencesModel');

    editorPreferencesModel.on('change:ui_theme', this.checkStyle, this);
    
  }

  onInit() {

    super.onInit();

    this.$link = this.createLink();
    this.checkStyle();

  }

  createLink() {

    if ( this.elements.$darkModeLink.length ) {
      return this.elements.$darkModeLink;
    }
    
    return jQuery( '<link>', {
      id: this.getSettings('darkModeLinkID'),
      rel: 'stylesheet',
      href: this.elements.$darkModeLink.attr('href')
    } );

  }

  checkStyle() {

    const editorPreferencesModel = this.getSettings('editorPreferencesModel');

    if ( 'light' === editorPreferencesModel.get('ui_theme') ) {
      this.$link.remove();
      return;
    }
    
    let timeout = setTimeout( () => {
      this.$link.attr( 'media', 'auto' === editorPreferencesModel.get('ui_theme') ? '(prefers-color-scheme: dark)' : '' ).appendTo( elementorCommon.elements.$body );
      clearTimeout(timeout);
    }, 150)
    
  }
  
}

export default LqdUITheme;